export default __webpack_public_path__ + "static/media/Lillian-Leon-testimonial.ef1dbd5e.jpg";